// extracted by mini-css-extract-plugin
export default {"rating":"FK-z","numberOfStars":"GK-z","count":"HK-z","barGraphSpacing":"IK-z","barGraph":"JK-z"};